<template>
  <div class="row">
    <div class="col col-12 info" :class="$config.project">
      <div class="col col-4 offset-1 stats">
        <div class="row">
          <div :class="{ lower: $config.project === 'site' }" class="col col-6 sm-6">
            <div class="box">
              <MonitorIcon /> {{ overview.lessons.total }} High Quality Lessons
            </div>
            <div class="box">
              <PracticeIcon /> {{ overview.practices }} Practical Tasks
            </div>
          </div>
          <div class="col col-6 sm-6">
            <div class="box">
              <ClockIcon />
              <span class="hours">
                {{ overview.hours }} {{ overview.hours === 1 ? 'Hour of Content' : 'Hours of Content' }}
              </span>
            </div>
            <div class="box">
              <MedalIcon /> Certificate of Achievement
            </div>
          </div>
        </div>
      </div>
      <h2 class="section-title h4">
        Course Overview
      </h2>
      <p class="body-2">
        {{ overview.description }}
      </p>
    </div>
  </div>
</template>

<script>
import MonitorIcon from '../../assets/svg/courses/monitor-colored.svg?vue-component';
import ClockIcon from '../../assets/svg/courses/clock-colored.svg?vue-component';
import PracticeIcon from '../../assets/svg/courses/practical-tasks-colored.svg?vue-component';
import MedalIcon from '../../assets/svg/courses/medal-colored.svg?vue-component';

export default {
  components: {
    MonitorIcon, ClockIcon, PracticeIcon, MedalIcon,
  },
  props: {
    overview: { type: Object, default: () => {}, required: true },
  },
};
</script>

<style lang="scss" scoped>
.info {
  .h4 {
    margin-bottom: var(--spacing-24);
  }

  > p {
    margin: 0;
    white-space: pre-line;
  }

  .stats {
    padding-right: 0;
    float: right;
    margin-bottom: var(--spacing-24);

    .box {
      background: var(--main-dark-shade-1);
      border-radius: 10px;
      width: 100%;
      height: 162px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      font-weight: 500;
      letter-spacing: 0.02em;
      color: var(--main-light);
      padding: var(--spacing-20) var(--spacing-20) 0;
      justify-content: flex-start;
      font-size: 18px;
      line-height: 110%;

      svg {
        width: 64px;
        height: 64px;
        margin-bottom: var(--spacing-12);
      }

      &:nth-child(1),
      &:nth-child(3) {
        margin-bottom: var(--spacing-28);
      }
    }

    .lower {
      margin-top: var(--spacing-16);
    }
  }

  &.lms {
    .h4 {
      margin-bottom: var(--spacing-16);
    }

    .stats {
      .box {
        height: 152px;
        padding: var(--spacing-20);
        font-size: 14px;
        line-height: 16px;

        svg {
          width: 53px;
          height: 53px;
          margin-bottom: var(--spacing-10);
        }
      }
    }
  }
}

@include bp($bp-laptop) {
  .info {
    .h4 {
      font-size: 24px;
    }

    .stats .box {
      font-size: 16px;
      line-height: 150%;
      padding: var(--spacing-20) var(--spacing-10) 0;
    }

    &.lms .stats .box {
      padding: var(--spacing-20) var(--spacing-16);
    }
  }
}

@include bp($bp-mobile) {
  .info {
    display: flex;
    flex-direction: column;
    height: 100%;

    .stats {
      order: 1;
      padding-left: 0;
      padding-right: 0;
      margin-top: var(--spacing-32);
    }
  }
}

@include bp($bp-phone) {
  .info .stats {
    .box {
      font-size: 16px;
    }

    .col {
      padding: var(--spacing-8);
      max-width: 50%;
    }
  }
}
</style>
